// PlatformPicker.tsx — widget del step 'platforms'.
// Qué hace: grilla de redes seleccionables (multi) + botón continuar.
// Qué exporta: PlatformPicker.
// Quién lo usa: NovahGenerateChat.

import { SocialNetwork } from '@agency-smm/shared';
import { PLATFORMS } from '../types';
import { WidgetWrap, PlatformGrid, PlatformBtn, ConfirmBtn } from '../styled';

interface Props {
  selectedPlatforms: Set<SocialNetwork>;
  togglePlatform: (id: SocialNetwork) => void;
  confirmPlatforms: () => void;
}

export function PlatformPicker({ selectedPlatforms, togglePlatform, confirmPlatforms }: Props) {
  return (
    <WidgetWrap>
      <PlatformGrid>
        {PLATFORMS.map((p) => (
          <PlatformBtn
            key={p.id}
            $active={selectedPlatforms.has(p.id)}
            onClick={() => togglePlatform(p.id)}
          >
            {p.icon} {p.label}
          </PlatformBtn>
        ))}
      </PlatformGrid>
      <ConfirmBtn onClick={confirmPlatforms} disabled={selectedPlatforms.size === 0}>
        Continue with {selectedPlatforms.size} platform{selectedPlatforms.size !== 1 ? 's' : ''}
      </ConfirmBtn>
    </WidgetWrap>
  );
}
